import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import homeEn from "../assets/locales/en/en.json";
import homeCe from "../assets/locales/ce/ce.json";

const resources = {
  en: {
    home: homeEn,
  },
  ce: {
    home: homeCe,
  },
};

i18next.use(initReactI18next).init({
  resources,
  lng: "en",
  debug: false,
  fallbackLng: "en",
  saveMissing: true,
});

export default i18next;
